export function getInitials(firstName: string | undefined, lastName: string | undefined) {
  if (!firstName && !lastName) return 'JD';
  return `${firstName ? firstName?.charAt(0) : ''}${lastName ? lastName?.charAt(0) : ''}`;
}

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const formatPhoneNumber = (phoneNumber: string | null) => {
  if (!phoneNumber) return '-';

  const digits = phoneNumber.replace(/\D/g, '');
  const countryCode = digits.slice(0, 2);
  const areaCode = digits.slice(2, 4);
  const firstPart = digits.slice(4, 9);
  const secondPart = digits.slice(9);

  return `+${countryCode} (${areaCode}) ${firstPart} ${secondPart}`;
};
